import { render, staticRenderFns } from "./route-square.vue?vue&type=template&id=3988aad1&"
import script from "./route-square.vue?vue&type=script&lang=js&"
export * from "./route-square.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3988aad1')) {
      api.createRecord('3988aad1', component.options)
    } else {
      api.reload('3988aad1', component.options)
    }
    module.hot.accept("./route-square.vue?vue&type=template&id=3988aad1&", function () {
      api.rerender('3988aad1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/route-square.vue"
export default component.exports